<template>
    <div class="flex flex-col tracking-wider w-full max-w-[768px]  h-full text-gray-700">
        <div v-if="isLoading" class="flex flex-col justify-center items-center h-64">
            <div class="w-full flex justify-center items-center">
                Please wait while we update your profile.
            </div>
            <div class="w-12 h-12 py-8">
                <LoadingSpinner />
            </div>
        </div>
        <div v-else class="flex flex-col w-full h-full">
            <div v-if="registrationResponseType" class="flex flex-col space-y-4">
                <div v-if="registrationResponseType=='success'" class="flex flex-col justify-center items-center space-y-4">
                    <div class="whitespace-pre-wrap w-full text-center">Profile has been successfully updated.</div>
                </div>
                <div v-else-if="registrationResponseType=='error'">
                    <div class="w-full whitespace-pre-wrap pretty text-center">{{ registrationResponseMessage }}</div>
                </div>
            </div>
            <form v-else @submit.prevent="submitEditForm" action="" class="h-full w-full flex flex-col justify-center items-center space-y-4">
                <div class="pb-3 w-full flex flex-col space-y-4">
                    <div class="w-full flex flex-col space-y-2">
                        <div class="">Username:</div>
                        <input class="p-3 w-full border border-gray-300  bg-gray-150 rounded-md" required disabled type="text" placeholder="Username" v-model="username">
                    </div>
                    <div class="w-full flex space-x-3">
                        <div class="w-full flex flex-col space-y-2">
                            <div>First Name:</div>
                            <input class="p-3 w-full border border-gray-300 rounded-md" required type="text" placeholder="First Name"  v-model="userData.first_name">
                        </div>
                        <div class="w-full flex flex-col space-y-2">
                            <div>Last Name:</div>
                            <input class="p-3 w-full border border-gray-300 rounded-md" required type="text" placeholder="Last Name"  v-model="userData.last_name">
                        </div>
                    </div>
                </div>
                <div class="w-full pt-6 border-t border-gray-300">
                    <button 
                        type="submit"
                        :disabled="!validForm"
                        class="px-4 py-3 bg-dark-primary text-white font-semibold leading-tight rounded-md transition duration-150 ease-in-out w-full"
                        :class="{ 'hover:bg-[#181B4E] hover:shadow-md focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg' : validForm, 'opacity-50' : !validForm}"
                    >
                        Update Profile
                    </button>
                </div>   
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { updateUser } from '@/services/User';
import LoadingSpinner from '../base-components/LoadingSpinner.vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { pageVisitLogger} from '@/composables/PageVisitLogging';

const store = useStore()
const router = useRouter()
const $toast = useToast()
const { navigateToPage } = pageVisitLogger()

const isLoading = ref(false)
const registrationResponseMessage = ref(null)
const registrationResponseLinks = ref([])
const registrationResponseType = ref(null)

let scriptTag = null;

const userData = reactive({
    first_name: store.state.auth.user.first_name,
    last_name: store.state.auth.user.last_name,
    // recaptcha_key: null,
})

const username = computed(() => {
    return store.state.auth.user.username
})

const password1InvalidMessage = computed(() => {
    if(userData.password1 && userData.password1.length < 8) {
        return 'Password must be at least 8 characters'
    }
    return null
})

const password2InvalidMessage = computed(() => {
    if(userData.password2 && userData.password2.length < 8) {
        return 'Password must be at least 8 characters'
    }
    return null
})

const nonMatchingPasswords = computed(() => {
    if(userData.password1 && userData.password2) {
        if(userData.password1 != userData.password2) {
            return true
        }
    }
    return false
})

const validForm = computed(() => {
    let isValid = false
    if((userData.first_name && userData.first_name != '')  && (userData.last_name && userData.last_name != '')) {
        isValid = true
    }
    return isValid
})

async function submitEditForm() {
    console.log('submitEditForm')
    // await recaptchaLoaded();
    // userData.recaptcha_key = await executeRecaptcha('register')
    isLoading.value = true
    const token = store.state.auth.token
    const payload = JSON.stringify(userData)
    const user_id = store.state.auth.user.id
    console.log(payload)
    const response = await updateUser(token, user_id, payload)
    console.log('response')
    console.log(response)

    setTimeout(() => {
        isLoading.value = false
        if(response && response.status == 200) {
            $toast.open({
                message: `Updated User profile`,
                type: 'success',
                duration: 5000
            })
            // registrationResponseType.value = 'success'
            store.dispatch('auth/updateUser', userData)
            navigateToPage('/profile/upload-photos', 'Upload Photos')
        } else {
            registrationResponseType.value = 'error'
                // registrationResponse.value = response.response.data.email[0]
            // const errorResponse = handleRestAuthRegisterResponseError(response)
            // registrationResponseMessage.value = errorResponse.message
            // registrationResponseLinks.value = errorResponse.links
        }
    }, 1000)
}
</script>